import React, { useContext } from "react";
import { Box, Heading } from "@chakra-ui/react";
import { AuthContext } from "../context/AuthContext";
import JobOpenings from "../components/careers/JobOpenings";

const CareersPage = () => {
    const { currLocation } = useContext(AuthContext);

    return (
        <Box
            as="main"
            pt={{ base: "24px", md: "20px" }}
            pl={{ base: "0px", md: "240px" }}
            pr={{ base: "0px", md: "30px" }}
            pb="20px"
            minH="100vh"
        >
            <JobOpenings locationId={currLocation} />
        </Box>
    );
};

export default CareersPage;